export function hasExistingSeries(foldersById) {
  return Object.values(foldersById).some((folder) => Boolean(folder.series_id));
}

export function shouldStartSeriesFolderIntro({ newProjectFlow, locationState, folder, phase }) {
  return Boolean(
    newProjectFlow &&
      locationState?.showSeriesFolderIntro &&
      folder?.series_id &&
      phase === "idle",
  );
}

export function shouldStartGeneratedProjectStoryBibleIntro({
  newProjectFlow,
  locationState,
  phase,
  hasShownIntro,
}) {
  return Boolean(
    newProjectFlow &&
      locationState?.showGeneratedProjectStoryBibleIntro &&
      phase === "idle" &&
      !hasShownIntro,
  );
}

export function arrangeNewProjectFlowEntries(entries, { includeNewCard, includePromoCard }) {
  const arrangedEntries = [];

  if (includeNewCard) {
    arrangedEntries.push({ type: "new-project" });
  }
  if (includePromoCard) {
    arrangedEntries.push({ type: "stack" });
  }

  return [...arrangedEntries, ...entries];
}
